import { Button, Modal, ModalBody, ModalFooter } from "@windmill/react-ui";
import React, { useContext } from "react";
import { FiTrash2 } from "react-icons/fi";
import { useLocation } from "react-router-dom";

//internal import
import spinnerLoadingImage from "assets/img/spinner.gif";
import { SidebarContext } from "context/SidebarContext";
import AdminServices from "services/AdminServices";
import StateServices from "services/StateServices";
import JobtitleServices from "services/JobtitleServices";
import PermitServices from "services/PermitServices";
import CityServices from "services/CityServices";
import RoleServices from "services/RoleServices";
import RegistrationTypeServices from "services/RegistrationTypeServices";
import AddonServices from "services/AddonServices";
import VehicleServices from "services/VehicleServices";
import CustomerServices from "services/CustomerServices";
import DriverServices from "services/DriverServices";
import VendorServices from "services/VendorServices";
import VehicleCategoryServices from "services/VehicleCategoryServices";
import VehicleModelServices from "services/VehicleModelServices";
import VehicleTypeServices from "services/VehicleTypeServices";
import AirportTimeServices from "services/AirportPickupPeriodicHikeTimeServices";
import HourTimeServices from "services/HourRentalPeriodicHikeTimeServices";
import FixedItineraryServices from "services/FixedItineraryServices";
import FixedItineraryPeriodicHikeServices from "services/FixedItineraryPeriodicHikeServices";
import AirportPickupBasicRateServices from "services/AirportPickupBasicRateServices";
import AirportPickupPeriodicHikeDayServices from "services/AirportPickupPeriodicHikeDayServices";
import DayRentalBasicRateServices from "services/DayRentalBasicRateServices";
import DayRentalPeriodicHikeDayServices from "services/DayRentalPeriodicHikeDayServices";
import HourRentalBasicRateServices from "services/HourRentalBasicRateServices";
import HrRentalPeriodicHikeDayServices from "services/HourRentalPeriodicHikeDayServices";
import TopSellingServices from "services/TopSellingServices";
import CityDistanceServices from "services/CityDistanceServices";
import MenuServices from "services/MenuServices";
import { useState } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import { notifyError, notifySuccess } from "utils/toast";
import SeoPageServices from "services/SeoPageServices";
import AirportServices from "services/AirportServices";
import LanguageDriverServices from "services/LanguageDriverServices";
import NotificationServices from "services/NotificationServices";
import SoldOutServices from "services/SoldOutServices";
import AgentsServices from "services/AgentsServices";
import ParkingServices from "services/ParkingServices";
import WhatsAppServices from "services/WhatsAppServices";
import TollServices from "services/TollServices";
import SeoVirtualServices from "services/SeoVirtualServices";
import OnewayPickupBasicRateServices from 'services/OnewayPickupServices';
import OnewayPickupPeriodicHikeDayServices from 'services/OnewayPeriodicHikeDayServices';
import OnewayPickupPeriodicHikeTimeServices from "services/OnewayPickupPeriodicHikeTimeServices";
import NewsServices from "services/NewsServices";
import FranchisePageServices from "services/FranchiseService";
import { itineraryOverRideMarginServices, overRideMarginServices } from "services/marginServices";
import TrustedCompaniesServices from "services/TrustedCompaniesServices";

const DeleteModal = ({ id, setIsCheck, title, useParamId, body }) => {
  const { isModalOpen, closeModal, setIsUpdate } = useContext(SidebarContext);
  const { setServiceId } = useToggleDrawer();
  const location = useLocation();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    // return notifyError("CRUD operation is disabled for this option!");
    try {
      setIsSubmitting(true);

      if (location.pathname === "/customers") {
        const res = await CustomerServices.deleteCustomer(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/employee") {
        const res = await AdminServices.deleteStaff(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/states") {
        const res = await StateServices.deleteState(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/city") {
        const res = await CityServices.deleteCity(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/city-distance") {
        const res = await CityDistanceServices.deleteCity(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/roles") {
        const res = await RoleServices.deleteRole(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/registration-type") {
        const res = await RegistrationTypeServices.deleteRegistrationType(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/addons") {
        const res = await AddonServices.deleteAddonType(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/vehicle-category") {
        const res = await VehicleCategoryServices.deleteVehicleCategory(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/vehicle-model") {
        const res = await VehicleModelServices.deleteVehicleModel(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/vehicle-type") {
        const res = await VehicleTypeServices.deleteVehicleType(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/basic-rate-fixed") {
        const res = await FixedItineraryServices.deleteFixedItinerary(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/periodic-hike-fixed") {
        const res = await FixedItineraryPeriodicHikeServices.deleteFixedItineraryPeriodicHike(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/airportPickup-basic-rate") {
        const res = await AirportPickupBasicRateServices.deleteAirportPickupBasicRate(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/oneway-periodic-hike-day") {
        const res = await OnewayPickupPeriodicHikeDayServices.deleteOnewayPickupPeriodicHikeDay(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/oneway-periodic-hike-time") {
        const res = await OnewayPickupPeriodicHikeTimeServices.deleteOnewayPickupPeriodicHikeTime(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/oneway-pickup-basicrate") {
        const res = await OnewayPickupBasicRateServices.deleteOnewayPickupBasicRate(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }


      if (location.pathname === "/basic-rate-day") {
        const res = await DayRentalBasicRateServices.deleteDayRentalBasicRate(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/periodic-hike-airport-day") {
        const res = await AirportPickupPeriodicHikeDayServices.deleteAirportPickupPeriodicHikeDay(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/vehicle") {
        const res = await VehicleServices.deleteVehicle(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/driver") {
        const res = await DriverServices.deleteDriver(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/vendor") {
        const res = await VendorServices.deleteVendor(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/jobtitle") {
        const res = await JobtitleServices.deleteJobtitle(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/permit") {
        const res = await PermitServices.deletePermit(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/periodic-hike-airport-time") {
        const res = await AirportTimeServices.deleteAirportPickupPeriodicHikeTime(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/periodic-hike-hour-time") {
        const res = await HourTimeServices.deleteHourRentalPeriodicHikeTime(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/periodic-hike-day") {
        const res = await DayRentalPeriodicHikeDayServices.deleteDayRentalPeriodicHikeDay(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/basic-rate-hour") {
        const res = await HourRentalBasicRateServices.deleteHourRentalBasicRate(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/periodic-hike-hour-day") {
        const res = await HrRentalPeriodicHikeDayServices.deleteHrRentalPeriodicHikeDay(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/holiday-package") {
        const res = await TopSellingServices.deleteSlider(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/menu") {
        const res = await MenuServices.deleteMenu(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/driverlanguage") {
        const res = await LanguageDriverServices.deleteLanguageDriver(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/seo-page") {
        const res = await SeoPageServices.deleteSeoPage(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/airport-city") {
        const res = await AirportServices.deleteAirport(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/notification") {
        const res = await NotificationServices.deleteNotification(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/soldOut") {
        const res = await SoldOutServices.deleteSoldout(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/agentslist") {
        const res = await AgentsServices.deleteAgents(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/parking") {
        const res = await ParkingServices.deleteParking(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/whatsapp") {
        const res = await WhatsAppServices.deleteTemplate(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/toll") {
        const res = await TollServices.deleteToll(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/seo-virtual") {
        const res = await SeoVirtualServices.deleteSeoVirtual(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }
      if (location.pathname === "/b2b-news") {
        const res = await NewsServices.deleteNews(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/franchise") {
        const res = await FranchisePageServices.deleteFranchise(id, body);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/periodic-margin") {
        const res = await overRideMarginServices.deleteOverRideMarginById(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/itinerary-periodic-margin") {
        const res = await itineraryOverRideMarginServices.deleteOverRideMarginById(id);
        setIsUpdate(true);
        notifySuccess(res.message);
        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

      if (location.pathname === "/trusted-companies") {
        const res = await TrustedCompaniesServices.deleteTrustedCompany(id);

        setIsUpdate(true);
        notifySuccess(
          res?.data?.message || res?.message || "Trusted company deleted successfully."
        );

        setServiceId("");
        closeModal();
        setIsSubmitting(false);
      }

    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setServiceId("");
      if (typeof setIsCheck === "function") {
        setIsCheck([]);
      }
      closeModal();
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ModalBody className="text-center custom-modal px-8 pt-6 pb-4">
          <span className="flex justify-center text-3xl mb-6 text-red-500">
            <FiTrash2 />
          </span>
          <h2 className="text-xl font-medium mb-2">
            Are You Sure! Want to Delete{" "}<span className="text-red-500">{title}</span>?
          </h2>
          <p>Do you really want to delete these records? You can't view this in your list anymore if you delete!</p>
        </ModalBody>

        <ModalFooter className=" justify-center">
          <Button
            className="relative align-bottom inline-flex items-center justify-center cursor-pointer leading-5 transition-colors duration-150 font-medium focus:outline-none px-4 py-2 rounded-lg text-sm text-gray-600 border-gray-200 border dark:text-gray-400 focus:outline-none rounded-lg border border-gray-200 px-4 w-full mr-3 flex items-center justify-center cursor-pointer h-12 bg-gray-200 w-full sm:w-auto hover:bg-white hover:border-gray-50"
            layout="outline"
            onClick={closeModal}
          >
            No, Keep It
          </Button>
          <div className="flex justify-end">
            {isSubmitting ? (
              <Button
                disabled={true}
                type="button"
                className="w-full h-12 sm:w-auto"
              >
                <img
                  src={spinnerLoadingImage}
                  alt="Loading"
                  width={20}
                  height={10}
                />{" "}
                <span className="font-serif ml-2 font-light">
                  Processing
                </span>
              </Button>
            ) : (
              <Button onClick={handleDelete} className="relative align-bottom inline-flex items-center justify-center cursor-pointer leading-5 transition-colors duration-150 font-medium focus:outline-none px-4 py-2 rounded-lg text-sm text-white bg-green-500 border border-transparent active:bg-green-600 hover:bg-green-600 focus:ring focus:ring-purple-300 w-full h-12 sm:w-auto" >
                Yes, Delete It
              </Button>

            )}
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default React.memo(DeleteModal);
